var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPatent24 = function SvgPatent24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.228 9.702a.24.24 0 0 0-.456 0l-.84 2.587a.24.24 0 0 1-.229.166h-2.72a.24.24 0 0 0-.14.434l2.2 1.599a.24.24 0 0 1 .087.268l-.84 2.587a.24.24 0 0 0 .369.268l2.2-1.599a.24.24 0 0 1 .282 0l2.2 1.599a.24.24 0 0 0 .37-.268l-.84-2.587a.24.24 0 0 1 .086-.268l2.2-1.599a.24.24 0 0 0-.14-.434h-2.72a.24.24 0 0 1-.228-.166l-.84-2.587Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V8.922a5 5 0 0 0-1.877-3.904L15.72 3.096A5 5 0 0 0 12.597 2H9ZM6 7a3 3 0 0 1 3-3h3.597c.135 0 .27.01.403.027V6a2 2 0 0 0 2 2h2.855a3 3 0 0 1 .145.922V17a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V7Z",
    fill: "currentColor"
  })));
};
export default SvgPatent24;